import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_packing_list_report_detailsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number }): 
  Promise<{ result: { lookupCode?: string, description?: string, packagedAmount?: number, upcCode?: string, PackagedId?: number, ShipmentLine?: { ShipmentId?: number }, Lot?: { MaterialId?: number, Material?: { IsFixedWeight?: boolean } }, getWeights?: { TotalGrossWeight?: number, TotalNetWeight?: number } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { lookupCode?: string, description?: string, packagedAmount?: number, upcCode?: string, PackagedId?: number, ShipmentLine?: { ShipmentId?: number }, Lot?: { MaterialId?: number, Material?: { IsFixedWeight?: boolean } }, getWeights?: { TotalGrossWeight?: number, TotalNetWeight?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, $keys: { ShipmentLine?: { ShipmentId?: number }, Lot?: { MaterialId?: number, Material?: { IsFixedWeight?: boolean } }, PackagedId?: number }[] }): 
  Promise<{ result: { lookupCode?: string, description?: string, packagedAmount?: number, upcCode?: string, PackagedId?: number, ShipmentLine?: { ShipmentId?: number }, Lot?: { MaterialId?: number, Material?: { IsFixedWeight?: boolean } }, getWeights?: { TotalGrossWeight?: number, TotalNetWeight?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number    }) {
      return false;
    }
}
